import { connect } from 'react-redux';
import * as FormsActions from 'ContentData/actions/Forms';
import * as formSelectors from 'ContentData/selectors/forms';
import { useState } from 'react';
import { useInterval } from 'ContentComponents/components/cmv2/hooks/useInterval';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error not typed
import FormattedDuration from 'I18n/components/FormattedDuration';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_MINUTE = 60000;
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.saveIndicator.${key}`;
const SavedMessage = ({
  updatedAt
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: i18nKey('sinceSave'),
    options: {
      duration: /*#__PURE__*/_jsx(FormattedDuration, {
        to: updatedAt,
        includeAffix: true
      })
    }
  }),
  placement: "bottom",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-selenium": "form-save-indicator-saved",
    message: i18nKey('saved')
  })
});
const FailedMessage = ({
  tooltipLabel,
  action
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: tooltipLabel,
  placement: "bottom",
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: i18nKey('failed.message'),
    options: {
      link: action
    }
  })
});
const SavedIndicator = ({
  label,
  isSaving,
  isFailed
}) => /*#__PURE__*/_jsx(LoadingSpinner, {
  use: "tertiary",
  size: "extra-small",
  layout: "inline",
  showLabel: true,
  showResult: !isSaving,
  failed: isFailed,
  label: /*#__PURE__*/_jsx("b", {
    children: label
  }),
  labelCompletedText: /*#__PURE__*/_jsx("b", {
    children: label
  }),
  margin: "0"
});
const mapStateToProps = (state, props) => {
  const {
    form: {
      updatedAt
    } = {}
  } = props;
  return {
    isSaving: formSelectors.getIsSaving(state),
    isFailed: formSelectors.getIsSavingFailed(state),
    isPreConditionFailed: formSelectors.getIsSavingPreconditionFailed(state),
    updatedAt: updatedAt
  };
};
const mapDispatchToProps = {
  saveForm: FormsActions.saveFormDraft,
  reloadFormDraft: FormsActions.reloadFormDraft
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const FormSaveIndicator = ({
  form,
  isSaving,
  isPreConditionFailed,
  isFailed,
  saveForm,
  reloadFormDraft,
  updatedAt
}) => {
  const [__, setTick] = useState(0);
  const {
    guid
  } = form;
  const onRetry = () => saveForm(guid);
  const onReload = () => reloadFormDraft(guid);
  useInterval(() => {
    setTick(previousTick => previousTick + 1);
  }, ONE_MINUTE);
  let label = /*#__PURE__*/_jsx(SavedMessage, {
    updatedAt: updatedAt
  });
  if (isSaving) {
    label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('saving')
    });
  } else if (isPreConditionFailed) {
    label = /*#__PURE__*/_jsx(FailedMessage, {
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('preconditionFailed.message')
      }),
      action: /*#__PURE__*/_jsx(Link, {
        onClick: onReload,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('preconditionFailed.retry')
        })
      })
    });
  } else if (isFailed) {
    label = /*#__PURE__*/_jsx(FailedMessage, {
      tooltipLabel: "",
      action: /*#__PURE__*/_jsx(Link, {
        onClick: onRetry,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('failed.retry')
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(SavedIndicator, {
    isSaving: isSaving,
    isFailed: isPreConditionFailed || isFailed,
    label: label
  });
};
export default connector(FormSaveIndicator);